import actions from '@/vuex/modules/accountAuth/actions'
import getters from '@/vuex/modules/accountAuth/getters'

const namespaced = true

/*
 * アカウントが持つ権限を取得・編集するmodule
 */
const accountAuth = {
  state: null,
  namespaced: namespaced,
  getters: getters,
  actions: actions,
}

export default accountAuth
